import { jsx as _jsx } from "react/jsx-runtime";
import { css } from 'styled-components';
export const ToolbarParent = ({ layoutType, ...rest }) => {
    return _jsx("div", { "data-toolbar-layout-type": layoutType, ...rest });
};
// ? Should this be extracted?
export const supportFieldLineLayout = (
// eslint-disable-next-line @typescript-eslint/no-explicit-any
subSelector = '') => css `
  [data-toolbar-layout-type='inner'] > & {
    & ${subSelector} {
      border-radius: 0;
    }
  }

  [data-toolbar-layout-type='vertical'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-bottom-left-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-top-right-radius: 0;
    }
  }

  [data-toolbar-layout-type='horizontal'] > & {
    &:first-child:not(:last-child) ${subSelector} {
      border-top-right-radius: 0;
      border-bottom-right-radius: 0;
    }
    &:not(:first-child):not(:last-child) ${subSelector} {
      border-radius: 0;
    }
    &:last-child:not(:first-child) ${subSelector} {
      border-top-left-radius: 0;
      border-bottom-left-radius: 0;
    }
  }
`;
//# sourceMappingURL=toolbarParent.js.map